import { CollectionList, Form } from '@mairistem/composants';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import PosteComptableContactListItem from './PosteComptableContactListItem';
import PosteComptableContactListItemForm from './PosteComptableContactListItemForm';

interface PosteComptableContactListProps {
  disabled?: boolean;
  telephone: string;
  mail: string;
  onChange?: (e: any) => void;
  control?: React.ReactNode;
  form?: React.ReactNode;
}

const PosteComptableContactList = (props: PosteComptableContactListProps) => {
  const {
    disabled,
    telephone,
    mail,
    onChange,
    control = PosteComptableContactListItem,
    form = PosteComptableContactListItemForm,
  } = props;

  const items = React.useMemo(() => {
    if (telephone || mail) {
      return [
        {
          key: '1',
          telephone,
          mail,
        },
      ];
    }

    return [];
  }, [telephone, mail]);

  const handleChange = React.useCallback(
    (e, item) => {
      if (onChange) {
        onChange({
          ..._.omit(item, 'key'),
        });
      }
    },
    [onChange],
  );

  return (
    <Form.Group width={16}>
      <Form.Field width={16} disabled={disabled}>
        <label>Informations de contact</label>
        <CollectionList
          limit={1}
          formTitle="Informations de contact"
          // @ts-expect-error
          items={items}
          {...(!disabled && {
            onItemCreate: handleChange,
            onItemUpdate: handleChange,
          })}
          itemControl={control as ReactNode}
          itemForm={form as ReactNode}
          modal={{ size: 'mini' }}
          style={{ margin: 0 }}
        />
      </Form.Field>
    </Form.Group>
  );
};

export default PosteComptableContactList;
